import {get,postJson,post} from '@/api/request/CommonRequest'
import axios from 'axios'
import { Message, Modal } from 'view-design'
import qs from 'qs'

export let smwxMethod_9_001 = {}

smwxMethod_9_001.selectList  = function (params) {
  return post('/mini-program-setting/selectList',params)
}

smwxMethod_9_001.getByIdforUpdate  = function (params) {
  return post('/mini-program-setting/getByIdforUpdate',params)
}

smwxMethod_9_001.getById  = function (params) {
  return post('/mini-program-setting/getById',params)
}

smwxMethod_9_001.insertRecord  = function (params) {
  return postJson('/mini-program-setting/insertRecord',params)
}

smwxMethod_9_001.updateRecord  = function (params) {
  return postJson('/mini-program-setting/updateRecord',params)
}

smwxMethod_9_001.getPhotosById  = function (params) {
  return post('/mini-program-setting/getHousePhotosById',params)
}


smwxMethod_9_001.deleteRecord  = function (params) {
  return post('/mini-program-setting/deleteRecord',params)
}

smwxMethod_9_001.hhzzOperate  = function (params) {
  return post('/mini-program-setting/hhzzOperate',params)
}

smwxMethod_9_001.insertFileRecord  = function (params) {
  return post('/api/file/insertFileRecord',params)
}

smwxMethod_9_001.operateXy  = function (params) {
  return postJson('/mini-program-setting/operate-xy',params)
}
smwxMethod_9_001.operateSmwx  = function (params) {
  return postJson('/mini-program-setting/operate-smwx',params)
}
smwxMethod_9_001.insertRepairInfoFromWeb  = function (params) {
  return postJson('/wechat/insertRepairInfoFromWeb',params)
}
// V2.0

smwxMethod_9_001.selectWxList  = function (params) {
  return postJson('/wechat/selectWxList',params)
}

smwxMethod_9_001.insertRepairRecord  = function (params) {
  return postJson('/wechat/insertRepairRecord',params)
}
smwxMethod_9_001.insertDetailRecord  = function (params) {
  return postJson('/mini-program-setting/insertDetailRecord',params)
}

smwxMethod_9_001.getHouseListByName  = function (params) {
  return postJson('/wechat/getHouseListByName',params)
}
smwxMethod_9_001.selectFilesForWechat  = function (params) {
  return postJson('/api/file/selectFilesForWechat',params)
}
smwxMethod_9_001.deleteWechatFile  = function (params) {
  return postJson('/api/file/deleteWechatFile',params)
}

smwxMethod_9_001.selectQuestionList  = function (params) {
  return postJson('/wechat/selectQuestionList',params)
}

smwxMethod_9_001.insertWechatFileRecord  = function (params) {
  return postJson('/api/file/insertWechatFileRecord',params)
}

// updateRepairRecordV2
smwxMethod_9_001.updateRepairRecordV2  = function (params) {
  return postJson('/mini-program-setting/updateRepairRecordV2',params)
}

smwxMethod_9_001.deleteDetailRecord  = function (params) {
  return post('/mini-program-setting/deleteDetailRecord',params)
}

smwxMethod_9_001.addNewEmptyQuestion  = function (params) {
  return post('/mini-program-setting/addNewEmptyQuestion',params)
}

smwxMethod_9_001.insertMaintenanceRecord = function (params) {
  return post('/mini-program-setting/insertMaintenanceRecord', params)
}







// loginMethod.login = function (params) {
//   return post('/user/login',params)
// }

// loginMethod.loginV2 = function (params) {
//   return post('/user/login_v2',params)
// }

